export function createModify(getter, setter) {
    return function modify(updateFn, s) {
        return setter(updateFn(getter(s)), s);
    };
}
//# sourceMappingURL=base.js.map